import { z } from "zod";

import {
  seoGeoFields,
  systemFields,
  zCastMember,
  zGenreRef,
  zMedia,
  zTinaStamp,
  zTranslations,
  zTransliterations,
} from "@/lib/zod/show-fragments";

/** Read-only view schema for the Plays show page — full PlayDbDto. */
export const playViewSchema = z
  .object({
    id: z.string(),
    title: z.string().nullish(),
    slug: z.string().nullish(),
    originalTitle: z.string().nullish(),
    originalLanguage: z.string().nullish(),
    overview: z.string().nullish(),
    media: zMedia.nullish(),
    genres: z.array(zGenreRef).nullish(),
    cast: z.array(zCastMember).nullish(),
    playwright: z.string().nullish(),
    director: z.string().nullish(),
    productionCompany: z.string().nullish(),
    durationInMinutes: z.number().nullish(),
    intermission: z.number().nullish(),
    interestedIn: z.number().nullish(),
    status: z.string().nullish(),
    enrichmentStatus: z.string().nullish(),
    // `PlayAIEnrichmentDbDto`: the shared SEO/GEO contract plus `overview`
    // (play is modelled on movie, not screening) — no `reasoning`/`features`,
    // which movie has and play's Firestore DTO does not.
    enrichment: z
      .object({
        ...seoGeoFields,
        transliterations: zTransliterations.nullish(),
        translations: zTranslations,
        overview: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    tags: z.array(z.string()).nullish(),
    metadata: z
      .object({
        source: z.string().nullish(),
        sourceId: z.string().nullish(),
        wikiDataId: z.string().nullish(),
        tina: zTinaStamp.nullish(),
      })
      .passthrough()
      .nullish(),
    hide: z.boolean().nullish(),
    ...systemFields,
  })
  .passthrough();

export type PlayViewType = z.infer<typeof playViewSchema>;
